module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"resource-snippet-consult":"Consulter"},"en":{"resource-snippet-consult":"Consult"}}')
  delete Component.options._Ctor
}
